import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from './user.reducer';

export const selectUserState = createFeatureSelector<fromUser.State>(fromUser.userFeatureKey);

export const selectSelf = createSelector(selectUserState, (state) => state.self);

export const selectIsLoading = createSelector(selectUserState, (state) => state.isComplete);

export const selectSelfError = createSelector(selectUserState, (state) => state.selfError);

export const selectIsComplete = createSelector(selectUserState, (state) => state.isLoading);

export const selectLoggedIn = createSelector(
  selectIsComplete,
  selectSelf,
  (isComplete, user) => isComplete && user != null
);

export const selectLoginFailed = createSelector(
  selectIsComplete,
  selectSelfError,
  (isComplete, error) => isComplete && error != null
);

// Waiting to start getting current user
export const selectIsWaiting = createSelector(
  selectIsComplete,
  selectIsLoading,
  (isComplete, isLoading) => !isComplete && !isLoading
);

export const selectUserOrgs = createSelector(selectUserState, (state) => state.organizations);
export const selectIsUserOrgsLoading = createSelector(selectUserState, (state) => state.isOrganizationsLoading);
export const selectIsUserOrgsComplete = createSelector(selectUserState, (state) => state.isOrganizationsComplete);
